import styled from "styled-components";

const OrderList = styled.ol`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
`;

export { OrderList };
